import { Button } from '@otter-ai/den-components';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { PURCHASE_UPGRADE_URLS } from '@/constants/path-constants';
import { useMoreZoomIntegrationsStatus } from '../../hooks/zoom/useMoreZoomIntegrationsStatus';
import { trackZoom } from '../../tracking/zoom-tracking';

/**
 * The upsell to upgrade the Otter plan to get more Zoom features.
 */
export function UpsellForMoreZoomIntegrations() {
  const t = useTranslations('settings:integrations.apps.zoom.upsell');
  const { showUpsell } = useMoreZoomIntegrationsStatus();

  if (!showUpsell) {
    return null;
  }

  return (
    <div className="flex flex-row gap-4 py-4 border-t border-subtle">
      <div className="grow">
        <h6 className="font-semibold text-sm">{t('moreZoomIntegrations')}</h6>
        <p className="text-sm text-subtle">
          {t('yourNotetakerCanStillJoinMeetings')}
        </p>
      </div>
      <Button asChild onClick={() => trackZoom.main.upgradeZoom()}>
        <Link
          href={PURCHASE_UPGRADE_URLS.ZOOM_MORE_INTEGRATION_UPGRADE}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('upgradeButton')}
        </Link>
      </Button>
    </div>
  );
}
